import React, { useState, useEffect } from "react";
import { Container, Form, Row, Col, Modal } from "react-bootstrap";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import { AvForm, AvField } from "availity-reactstrap-validation";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Dropdown from "react-bootstrap/Dropdown";
import {
  updateselected,
  FetchScheduledList,
  RejectScheduleRecord,
} from "../../services/scheduledService";
import api from "../../api";
import { toast } from "react-toastify";
import action1 from "../../assets/images/icon/action_1.svg";
import action2 from "../../assets/images/icon/action_2.svg";
import action3 from "../../assets/images/icon/action_3.svg";
import serach_icon from "../../assets/images/icon/search-icon.svg";
import { CSVLink } from "react-csv";
import { Button } from "reactstrap";
import { downloadCSVReport } from "helpers/backend_helper";
import mail from "../../assets/images/icon/mail.svg";
import dowanload_csv from "../../assets/images/icon/downloadcsv.svg";
import filtericon from "../../assets/images/icon/filter-icon.svg";
import threedots from "../../assets/images/icon/three-dots.svg";
import cross from "../../assets/images/icon/cross.svg";
import name_icon from "../../assets/images/icon/name01.svg";
import job from "../../assets/images/icon/job-port.svg";
import education from "../../assets/images/icon/education-role.svg";
import star_exp from "../../assets/images/icon/exp_job.svg";
import selected_icon from "../../assets/images/icon/selected2.png";
import {
  updatestatus,
  FetchFilterInfo,
  getFilteredList,
} from "services/pendingService";
import authHeader from "helpers/jwt-token-access/auth-token-header";
import { checkPermissionStatus } from "helpers/utils";
function ScheduledList(props) {
  const [isFormVisible, setIsFormVisible] = useState(false);
  const [isForm2Visible, setIsForm2Visible] = useState(false);
  const [isForm3Visible, setIsForm3Visible] = useState(false);
  const [ScheduledData, setScheduledData] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [selectedApplId, setSelectedApplId] = useState(null);
  const [scheduledInterviews, setScheduledInterviews] = useState([]);
  const [commentsError, setCommentsError] = useState("");
  const [interviewIdForReschedule, setInterviewIdForReschedule] =
    useState(null);
  const [InterviewIdForFeedback, setInterviewIdForFeedback] = useState(null);
  const [selectedCandidate, setSelectedCandidate] = useState({
    name: "",
    roleType: "",
  });
  const [msg, setMsg] = useState("");
  const [formData, setFormData] = useState({
    int_schedule_date: "",
    int_schedule_time: "",
    interview_title: "",
    interviewer_time: "",
    address: "",
    req_documents: "",
  });
  const [formDatas, setrescheduleData] = useState({
    int_schedule_date: "",
    int_schedule_time: "",
    f2f_address: "",
  });
  const [formData3, setfeedbackData] = useState({
    comment: "",
  });

  //tabs
  const [activeTab, setActiveTab] = useState("tab1");
  const handleTabClick = tab => {
    setActiveTab(tab);
  };

  const [roleTypes, setRoleTypes] = useState([]);
  const [role, setRole] = useState("");
  const [gender, setGender] = useState("");
  const [sourceType, setSourceType] = useState([]);
  const [source, setSource] = useState("");
  const [states, setStates] = useState([]);
  const [region, setRegion] = useState("");
  const [state, setState] = useState("");
  const [areas, setAreas] = useState([]);
  const [area, setArea] = useState("");
  const [cities, setCities] = useState([]);
  const [filteredCities, setFilteredCities] = useState([]);
  const [city, setCity] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [query, setQuery] = useState("");

  const [csvData, setCSVData] = useState([]);
  const [comments, setComments] = useState(""); // Initialize comment state
  const [offerLetter, setOfferLetter] = useState(null); // Initialize offerLetter state

  const handleCSVDownload = async e => {
    e.preventDefault();
    let data = {};
    let selectedIds = [];
    let allData = ScheduledData?.map(el => {
      if (el?.checked) {
        selectedIds.push(el?.appl_id);
      }
      return el;
    });
    if (selectedIds?.length > 0) {
      data = {
        type: "selective",
        candidateIds: selectedIds?.join(","),
        listType: "scheduled",
      };
    } else {
      data = {
        type: "All",
        candidateIds: "",
        listType: "scheduled",
      };
    }

    try {
      await downloadCSVReport(data)
        .then(res => {
          setCSVData(res?.data);
          setTimeout(() => {
            let element = document.getElementById("downloadCSV");
            element.click();
          }, 1000);
        })
        .catch(err => {
          console.log(err);
          return [];
        });
    } catch (err) {
      return [];
    }
  };
  const getScheduleList = async () => {
    await FetchScheduledList()
      .then(res => {
        //console.log('24:responsedata',res.data.data)
        if (res.data.status) {
          setScheduledData(res.data.data);
        } else {
          toast.error("No data available");
        }
      })
      .catch(err => {
        toast.error("No data Available");
      });
  };
  // Fetch Faqs listing data
  useEffect(() => {
    getScheduleList();
    getFilterInfo();
    document.title = "NeuroTal - Scheduled Applications";
  }, []);

  const handleCheck = (e, app_id) => {
    let value = e.target.checked;
    let allUsers = ScheduledData?.map(el => {
      if (el?.appl_id === app_id) {
        el.checked = value;
      }
      return el;
    });
    setScheduledData(allUsers);
  };

  const handleStateChange = e => {
    setCity("");
    setState(e.target.value);
    let cityList = cities?.filter(
      el => el?.state_id === parseInt(e.target.value)
    );
    setFilteredCities(cityList);
  };

  const handleSubmit = () => {
    let payload = {
      type: "scheduled",
      gender: gender,
      role: role,
      source: source,
      state: state,
      city: city,
      area: area,
      startDate: startDate,
      endDate: endDate,
    };
    getFilteredList(payload)
      .then(res => {
        if (res.data.status) {
          setScheduledData(res.data.data);
        } else {
          toast.error("No data available");
        }
        close();
      })
      .catch(err => console.log(err));
  };

  const handleGenderChange = e => {
    if (gender === e.target.name) {
      setGender("");
    } else {
      setGender(e.target.name);
    }
  };

  const clearFilters = () => {
    setGender("");
    setRole("");
    setArea("");
    setState("");
    setCity("");
    setStartDate("");
    setEndDate("");
    setSource("");
  };

  const renderCheck = item => {
    let searchableText = JSON.stringify(item)?.toLowerCase();
    if (searchableText?.includes(query?.toLowerCase())) {
      return true;
    }
    return false;
  };

  const getFilterInfo = async () => {
    await FetchFilterInfo()
      .then(res => {
        let filterData = res?.data?.data || "";
        if (filterData) {
          setCities(filterData?.cities || []);
          setAreas(filterData?.areas || []);
          setRoleTypes(filterData?.roles || []);
          setSourceType(filterData?.sources || []);
          setStates(filterData?.states || []);
        }
      })
      .catch(err => {
        console.log(err);
      });
  };

  // Bootstrap table columns
  const columns = [
    {
      dataField: "appl_id",
      text: "Appl. No",
      classes: "total",
      formatter: (cellContent, row) => {
        const applyDate = new Date(row.apply_date);
        const formattedDate =
          row.appl_id +
          "/" +
          (applyDate.getMonth() + 1) +
          "" +
          applyDate.getFullYear();
        return (
          <div className="date-tabel">
            <input
              defaultChecked={row?.checked || false}
              onClick={e => handleCheck(e, row?.appl_id)}
              type="checkbox"
            />
            <label>{formattedDate}</label>
          </div>
        );
      },
    },
    {
      dataField: "name",
      text: "Name",
      classes: "application-name ",
    },
    {
      dataField: "email_id",
      text: "Email Id",
      classes: "application-email ",
    },
    {
      dataField: "mobile",
      text: "Mobile No.",
      classes: "application-normal",
    },
    {
      dataField: "job_user.master_reference_table.gender",
      text: "Gender",
      classes: "application-normal",
    },

    {
      dataField: "highest_qualification",
      text: "Education",
      classes: "application-normal education",
    },
    {
      dataField: "job_user.total_experience",
      text: "Total Exp",
      classes: "application-normal",
    },
    {
      dataField: "vacancy.title",
      text: "Job Role",
      classes: "application-normal",
    },
    {
      dataField: "master_city.city",
      text: "City",
      classes: "application-normal",
    },
    {
      dataField: "int_schedule_date",
      text: "Int Schedule Date",
      classes: "application-normal",
    },
    {
      dataField: "",
      text: "Actions",
      formatter: (cell, row) => {
        let appl_id = row.appl_id;
        // console.log(appl_id);
        return (
          <div className="action-application">
            {checkPermissionStatus("scheduled-list", "addrounds") && (
              <div className="action-one">
                <Link
                  to="#"
                  onClick={() =>
                    handleOpenModal(appl_id, row.name, row.vacancy.title)
                  }
                >
                  <img src={action1} alt="" />
                  <span>Add Rounds</span>
                </Link>
              </div>
            )}
            {checkPermissionStatus("scheduled-list", "selectcandidate") && (
              <div className="action-one">
                <Link to="#" onClick={() => open_slider(appl_id, 1)}>
                  <img src={selected_icon} alt="" />
                  <span>Selected</span>
                </Link>
              </div>
            )}
            {checkPermissionStatus("scheduled-list", "reject") && (
              <div className="action-one">
                <Link to="#" onClick={() => open_slider(appl_id, 2)}>
                  <img src={action3} alt="" />
                  <span>Reject</span>
                </Link>
              </div>
            )}
            <div className="action-one filter">
              <Dropdown>
                <Dropdown.Toggle variant="success" id="dropdown-basic">
                  <img src={threedots} alt="" />
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    disabled={!checkPermissionStatus("scheduled-list", "view")}
                    href={"candidate_consolidate/view-details/" + appl_id}
                  >
                    View Details
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        );
      },
    },
  ];
  ///reject popup
  const [isVisibles, setIsVisibles] = useState(false);
  const [isReject, setIsReject] = useState(false);

  const closes = () => {
    setIsReject(false);
    setCommentError("");
  };

  ///hold popup
  const [isSelected, setisSelected] = useState(false);
  const [candidateDetails, setCandidateDetails] = useState({});
  const open_slider = async (appl_id, status) => {
    try {
      const response = await api.get(
        `${process.env.REACT_APP_API_URL}/admin/common/fetch-details/${appl_id}`
      );
      const data = response.data;

      if (data.status && data.data.length > 0) {
        setCandidateDetails(data.data[0]);
      } else {
        console.error("Invalid data format received from API:", data);
      }
    } catch (error) {
      console.error("Error fetching candidate details:", error);
    }
    if (status == 1) {
      setisSelected(!isVisibles);
    } else if (status == 2) {
      setIsReject(!isReject);
    }
  };

  const customTotal = (from, to, size) => (
    <span className="react-bootstrap-table-pagination-total">
      Showing rows {from} to {to} of {size}
    </span>
  );

  let options = {
    paginationSize: 1,
    pageStartIndex: 1,
    alwaysShowAllBtns: true, // Always show next and previous button
    withFirstAndLast: true, // Hide the going to First and Last page button
    hideSizePerPage: true, // Hide the sizePerPage dropdown always
    hidePageListOnlyOnePage: true, // Hide the pagination list when only one page
    firstPageText: false,
    prePageText: false,
    nextPageText: false,
    lastPageText: false,
    nextPageTitle: "First page",
    prePageTitle: "Pre page",
    firstPageTitle: "Next page",
    lastPageTitle: "Last page",
    showTotal: true,
    paginationTotalRenderer: customTotal,
    disablePageTitle: false,
  };

  const rowClasses = (row, rowIndex) => {
    return rowIndex % 2 === 0 ? "even-row" : "odd-row";
  };

  ///modal
  const [isVisible, setIsVisible] = useState(false);

  const filter_icon = () => {
    setIsVisible(!isVisible);
  };

  const close = () => {
    setIsVisible(false);
  };

  // Delete Faqs
  const handleRejectedRecords = appl_id => {
    console.log("deleting id:::", appl_id);
    RejectScheduleRecord(appl_id)
      .then(res => {
        console.log("response", res.status);
        if (res.status == 200) {
          let messages = toast.success("Record Rejected successfully.");
          // window.location.reload();
        } else {
          toast.error(res?.data?.message);
          ref.current?.scrollIntoView({ behavior: "smooth" });
        }
      })
      .catch(error => {
        console.log(error);
      });
  };

  const handleOpenModal = (appl_id, name, roleType) => {
    setSelectedApplId(appl_id);
    setSelectedCandidate({
      name: name,
      roleType: roleType,
    });
    setShowModal(true);
  };

  // Close Modal
  const handleCloseModal = () => {
    setShowModal(false);
    setIsForm2Visible(false);
    setIsFormVisible(false);
    setIsForm3Visible(false);
  };

  const handleDeleteInterview = async interviewId => {
    if (window.confirm("Are you sure you want to delete this interview?")) {
      try {
        // Use the interviewId to send a request to delete the interview
        await api.delete(
          `${process.env.REACT_APP_API_URL}/admin/schedule/delete-schedule/${interviewId}`
        );
        setMsg("Interview deleted successfully");
      } catch (error) {
        setMsg(error.message);
      }
    }
    //FetchScreeningList()
    // window.location.reload();
    setShowModal(false);
  };

  const convertDateFormat = dateString => {
    const dateObject = new Date(dateString);
    const year = dateObject.getFullYear();
    const month = String(dateObject.getMonth() + 1).padStart(2, "0");
    const day = String(dateObject.getDate()).padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;

    return formattedDate;
  };

  const handleInterviewSubmit = async e => {
    e.preventDefault(); // Prevent the default form submission behavior
    const dynamicApplId = selectedApplId;

    let newFormData = JSON.parse(JSON.stringify(formData));

    const formattedDate = convertDateFormat(newFormData.int_schedule_date);
    newFormData.int_schedule_date = formattedDate;
    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/scheduleintr/scheduledInterstore/${dynamicApplId}`,
        newFormData
      );
      toast.success("Rounds Added successfully");
      getScheduleList();
    } catch (error) {
      console.error("Error submitting form:", error.message);
      toast.error("Error submitting form");
    }
    setShowModal(false);
  };

  const handleRescheduleSubmit = async e => {
    e.preventDefault();
    const dynamicInterviewId = interviewIdForReschedule;

    let newFormData = JSON.parse(JSON.stringify(formDatas));

    const formattedDate = convertDateFormat(newFormData.int_schedule_date);
    // console.log(formattedDate);
    newFormData.int_schedule_date = formattedDate;
    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/admin/schedule/update-reschedule/${dynamicInterviewId}`,
        newFormData
      );
      setMsg("Form submitted successfully");
    } catch (error) {
      console.error("Error rescheduling interview:", error.message);
      setMsg("Error submitting form");
    }
    getScheduleList();
    setIsForm3Visible(false);
    setShowModal(false);
  };

  const handlefeedbackSubmit = async e => {
    e.preventDefault();
    const feedbackid = InterviewIdForFeedback;
    console.log("feedback" + feedbackid);
    setfeedbackData(prevData => ({
      ...prevData,
    }));
    try {
      await api.post(
        `${process.env.REACT_APP_API_URL}/admin/schedule/update-feedback/${feedbackid}`,
        formData3
      );
      setMsg("Feedback submitted successfully");
    } catch (error) {
      console.error("Error rescheduling interview:", error.message);
      setMsg("Error submitting Feedback");
    }
    getScheduleList();
    setIsForm3Visible(false);
    setShowModal(false);
  };

  const changecomment = e => {
    setfeedbackData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const changeHandlers = e => {
    setrescheduleData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  const changeHandler = e => {
    setFormData(prevFormData => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };
  useEffect(() => {
    const fetchData = async () => {
      if (selectedApplId !== null) {
        try {
          const response = await api.get(
            `${process.env.REACT_APP_API_URL}/scheduleintr/scheduled-interviews/${selectedApplId}`
          );

          const data = response.data;

          if (Array.isArray(data)) {
            setScheduledInterviews(data);
          } else {
            console.error("Invalid data format received from API:", data);
          }
        } catch (error) {
          console.error("Error fetching scheduled interviews:", error);
        }
      }
    };

    fetchData();
  }, [selectedApplId]);
  const handleToggleForm = () => {
    setIsFormVisible(prev => !prev);
  };
  const handleToggleForm2 = interviewId => {
    setInterviewIdForReschedule(interviewId);
    setIsForm2Visible(prev => !prev);
  };
  const handleToggleFeeddback = interviewId => {
    setInterviewIdForFeedback(interviewId);
    setIsForm3Visible(prev => !prev);
  };
  const [comment, setComment] = useState("");
  const [commentError, setCommentError] = useState("");
  const [isCommentRequired, setIsCommentRequired] = useState(false);
  const handleChange = e => {
    setComment(e.target.value);
    setCommentError("");
  };

  const validateComment = () => {
    if (isCommentRequired && !comment.trim()) {
      setCommentError("Comment is required.");
      return false;
    }
    // You can add more validation rules here if needed
    return true;
  };
  const toggleCommentRequirement = () => {
    setIsCommentRequired(prevIsCommentRequired => !prevIsCommentRequired);
  };

  const validateComments = () => {
    if (!comments.trim()) {
      setCommentsError("Comment is required.");
      return false;
    }
    // You can add more validation rules here if needed
    return true;
  };

  const selected_close = () => {
    setisSelected(false);
    setCommentsError("");
  };
  const handleConfirm = (appl_id, status, comment) => {
    if (validateComment()) {
      console.log("comment", comment);
      updatestatus(appl_id, status, comment, 2)
        .then(res => {
          if (res.status === 200) {
            if (status === 5) {
              toast.success("Record Rejected successfully.");
            } else if (status === 3) {
              toast.success("Record Selected successfully.");
            } else {
              toast.success("Comment Added successfully.");
            }
          } else {
            toast.error(res?.data?.message);
          }
        })
        .catch(error => {
          console.log(error);
        });
      getScheduleList();
      closes();
    } else {
      console.log("Validation error:", commentError);
    }
  };

  const handleSelected = (appl_id, user_id) => {
    if (validateComments()) {
      let formData = new FormData();
      formData.append("offer_letter", offerLetter);
      formData.append("comments", comments);
      formData.append("status_change_from", "2");
      formData.append("status", "3");
      formData.append("user_id", user_id);
      updateselected(appl_id, formData)
        .then(res => {
          if (res.status === 200) {
            toast.success("Offer letter sent Successfully.");
          } else {
            toast.error(res?.data?.message);
          }
          // FetchScreeningList()
          // window.location.reload();
        })
        .catch(error => {
          console.log(error);
        });
      selected_close();
    } else {
      console.log("Validation error:", commentError);
    }
  };
  const [inputTypeStart, setInputTypeStart] = useState("text");
  const [inputTypeEnd, setInputTypeEnd] = useState("text");

  if (!checkPermissionStatus("scheduled-list", "view")) {
    return (
      <div className="page-content">
        <h4 className="text-center">Access Denied.</h4>
      </div>
    );
  }
  ///////////
  return (
    <>
      <div className="pending-list-page">
        <div className="tabbing-wrapper d-flex justify-content-between mt-2 mb-4">
          <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
            <ul className="tab-btn-wrapper d-flex align-items-center">
              <li>
                <Link
                  to="/all-applications"
                  className="tab-link"
                  id="archive-list"
                >
                  All
                </Link>
              </li>
              <li>
                <Link to="/pending-list" className="tab-link" id="pending-list">
                  New Applications
                </Link>
              </li>
              <li>
                <Link
                  to="/screening-list"
                  className="tab-link"
                  id="screening-list"
                >
                  Assessment Center
                </Link>
              </li>
              {/* <li>
                <Link
                  to="/scheduled-list"
                  className="tab-link active"
                  id="scheduled-list"
                >
                  Scheduled Applications
                </Link>
              </li> */}
              <li>
                <Link
                  to="/selected-list"
                  className="tab-link"
                  id="selected-list"
                >
                  Selected Applications
                </Link>
              </li>
              <li>
                <Link
                  to="/onboarded-list"
                  className="tab-link"
                  id="onboarded-list"
                >
                  Onboarded Applications
                </Link>
              </li>
              <li>
                <Link to="/onhold-list" className="tab-link" id="onhold-list">
                  On hold Applications
                </Link>
              </li>
              <li>
                <Link
                  to="/rejected-list"
                  className="tab-link"
                  id="rejected-list"
                >
                  Rejected Applications
                </Link>
              </li>
              <li>
                <Link
                  to="/archive-list"
                  className="tab-link "
                  id="archive-list"
                >
                  Archived Applications
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            // aria-labelledby="pills-home-tab"
          >
            <div className="tabel-application table-responsive pb-3">
              <div className="table-data-search">
                <div className="total-record">
                  <h5>
                    Total Records: <span>{ScheduledData?.length || 0}</span>
                  </h5>
                </div>
                <div className="total-serachbar">
                  <div className="serach-bar-top">
                    <form class="form-inline">
                      <input
                        class="form-control mr-sm-2"
                        type="search"
                        placeholder="Search by mobile no., application no..."
                        aria-label="Search"
                        onChange={e => setQuery(e.target.value)}
                      />
                      <span>
                        <img src={serach_icon} alt="search" />
                      </span>
                    </form>
                  </div>
                  {checkPermissionStatus("scheduled-list", "downloadcsv") && (
                    <div className="take-text">
                      <CSVLink
                        data={csvData}
                        headers={[
                          {
                            key: "appl_id",
                            label: "Application ID",
                          },
                          {
                            key: "name",
                            label: "Name",
                          },
                          {
                            key: "mobile",
                            label: "Mobile Number",
                          },
                          {
                            key: "email_id",
                            label: "Email ID",
                          },
                          {
                            key: "createdAt",
                            label: "Created Date",
                          },
                          {
                            key: "f2f_address",
                            label: "Address",
                          },
                        ]}
                        filename={`ScheduledApplicationList.csv`}
                        id="downloadCSV"
                      >
                        <Button
                          color="info"
                          onClick={e => handleCSVDownload(e)}
                          outline
                        >
                          <img src={dowanload_csv} alt="Download" /> Download
                          CSV
                        </Button>
                      </CSVLink>
                    </div>
                  )}
                  <div className="take-text filter" onClick={filter_icon}>
                    <h5>
                      <span>
                        <img src={filtericon} alt="" />
                      </span>
                      Filters
                    </h5>
                  </div>
                </div>
              </div>
              {ScheduledData.length > 0 ? (
                <BootstrapTable
                  keyField="id"
                  data={ScheduledData?.filter(renderCheck)}
                  columns={columns}
                  pagination={paginationFactory(options)}
                  rowClasses={rowClasses}
                  hover
                  responsive
                />
              ) : (
                <table className="table table-hover table-bordered">
                  <thead>
                    <tr>
                      <th>Appl. No</th>
                      <th>Name</th>
                      <th>Email Id</th>
                      <th>Mobile No.</th>
                      <th>Gender</th>
                      <th>Education</th>
                      <th>Total Exp</th>
                      <th>Job Role</th>
                      <th>City</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colSpan="10" className="text-center">
                        <h3>No data found</h3>
                      </td>
                    </tr>
                  </tbody>
                </table>
              )}
            </div>
          </div>
        </div>
      </div>
      {isVisible && (
        <div className="filter-shadow">
          <div className="filters-cards">
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4>Filters</h4>
              </div>
              <div className="filter-content cross" onClick={close}>
                <img src={cross} alt="" />
              </div>
            </div>
            <div className="bordertops"></div>
            <div className="application-gender">
              <h5>{t(`Bulk Import.Select Applicant Gender`)}</h5>

              <div className="application-button">
                <div class="cat action">
                  <label>
                    <input
                      type="checkbox"
                      name="Male"
                      onChange={e => handleGenderChange(e)}
                      checked={gender === "Male"}
                    />
                    <span>Male</span>
                  </label>
                </div>
                <div class="cat action">
                  <label>
                    <input
                      type="checkbox"
                      name="Female"
                      onChange={e => handleGenderChange(e)}
                      checked={gender === "Female"}
                    />
                    <span>Female </span>
                  </label>
                </div>
                <div class="cat action">
                  <label>
                    <input
                      type="checkbox"
                      name="Other"
                      onChange={e => handleGenderChange(e)}
                      checked={gender === "Other"}
                    />
                    <span>Other</span>
                  </label>
                </div>
              </div>
            </div>
            <div className="filter-cards-form">
              <form className="form-inline">
                <div className="col-lg-12">
                  <Form.Select
                    onChange={e => setRole(e.target.value)}
                    aria-label="Default select example"
                    value={role}
                  >
                    <option value="">Select Role Type</option>
                    {roleTypes?.map(el => {
                      return <option value={el?.value}>{el?.label}</option>;
                    })}
                  </Form.Select>
                </div>

                <div className="col-lg-12">
                  <Form.Select
                    onChange={e => setSource(e.target.value)}
                    aria-label="Default select example"
                    value={source}
                  >
                    <option value="">Select Source Type</option>
                    {sourceType?.map(el => {
                      return <option value={el?.value}>{el?.label}</option>;
                    })}
                  </Form.Select>
                </div>

                {/* <div className="col-lg-12">
                    <Form.Select
                      onChange={(e) => setRegion(e.target.value)}
                      aria-label="Default select example"
                      value={region}
                    >
                      <option value="" >Select Region</option>
                      {regions?.map((el) => {
                        return <option value={el?.value}>{el?.label}</option>
                      })}
                    </Form.Select>
                  </div> */}

                <div className="col-lg-12">
                  <Form.Select
                    onChange={e => handleStateChange(e)}
                    aria-label="Default select example"
                    value={state}
                  >
                    <option value="">Select State</option>
                    {states?.map(el => {
                      return <option value={el?.value}>{el?.label}</option>;
                    })}
                  </Form.Select>
                </div>

                <div className="col-lg-12">
                  <Form.Select
                    onChange={e => setCity(e.target.value)}
                    aria-label="Default select example"
                    value={city}
                  >
                    <option value="">Select City</option>
                    {filteredCities?.map(el => {
                      return <option value={el?.value}>{el?.label}</option>;
                    })}
                  </Form.Select>
                </div>

                <div className="col-lg-12">
                  <Form.Select
                    onChange={e => setArea(e.target.value)}
                    aria-label="Default select example"
                    value={area}
                  >
                    <option value="">Select Area</option>
                    {areas?.map(el => {
                      return <option value={el?.value}>{el?.label}</option>;
                    })}
                  </Form.Select>
                </div>

                {/* <div className="col-lg-12">
                    <Form.Group
                      controlId="formDate"
                      className="input-formtext d-flex"
                    >
                      <span>Start Date :</span>
                      <input
                        type="date"
                        class="form-control"
                        id="date"
                        onChange={e => setStartDate(e.target.value)}
                        placeholder="Start Date"
                        value={startDate}
                      />
                    </Form.Group>
                  </div>

                  <div className="col-lg-12">
                    <Form.Group
                      controlId="formDate"
                      className="input-formtext d-flex"
                    >
                      <span>End Date :</span>
                      <input
                        type="date"
                        class="form-control"
                        id="date"
                        onChange={e => setEndDate(e.target.value)}
                        value={endDate}
                      />
                    </Form.Group>
                  </div> */}

                <div className="col-lg-12">
                  <Form.Group
                    controlId="formStartDate"
                    className="input-formtext d-flex"
                  >
                    <input
                      placeholder="Start Date"
                      className="form-control"
                      type={inputTypeStart}
                      onChange={e => setStartDate(e.target.value)}
                      onFocus={() => setInputTypeStart("date")}
                      onBlur={() => setInputTypeStart("text")}
                      id="startDate"
                      value={startDate}
                    />
                  </Form.Group>
                </div>

                <div className="col-lg-12">
                  <Form.Group
                    controlId="formEndDate"
                    className="input-formtext d-flex"
                  >
                    <input
                      placeholder="End Date"
                      className="form-control"
                      type={inputTypeEnd}
                      onChange={e => setEndDate(e.target.value)}
                      onFocus={() => setInputTypeEnd("date")}
                      onBlur={() => setInputTypeEnd("text")}
                      id=""
                      value={endDate}
                    />
                  </Form.Group>
                </div>
              </form>
              <div className="col-lg-12">
                <div className="serach-btn">
                  <button
                    className="btn btn-primary reset"
                    onClick={() => clearFilters()}
                  >
                    Reset
                  </button>
                  <button
                    className="btn btn-primary search"
                    onClick={() => handleSubmit()}
                  >
                    Search
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {isReject && (
        <div className="filter-shadow reject-people-data">
          <div className="filters-cards">
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4>Reject Application</h4>
              </div>
              <div className="filter-content cross" onClick={closes}>
                <img src={cross} alt="" />
              </div>
            </div>
            <div className="bordertops"></div>
            <div className="reject-people data">
              <div className="data-people">
                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={name_icon} alt="" />
                  </div>
                  <div className="people-name">
                    <p>Name</p>
                    <h4>{candidateDetails.name}</h4>
                  </div>
                </div>

                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={job} alt="" />
                  </div>
                  <div className="people-name">
                    <p>Job Role</p>
                    <h4>{candidateDetails.vacancy?.title}</h4>
                  </div>
                </div>
              </div>

              <div className="data-people">
                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={education} alt="" />
                  </div>
                  <div className="people-name">
                    <p>Education</p>
                    <h4>{candidateDetails.highest_qualification}</h4>
                  </div>
                </div>

                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={star_exp} alt="" />
                  </div>
                  <div className="people-name">
                    <p>Total Exp.</p>
                    <h4>{candidateDetails.job_user.total_experience}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-cards-form reject-data">
              <h4>Are you sure you want to reject the candidate?</h4>
              <p>
                Once you click 'Reject', will not be considered for a job for
                the next three months.
              </p>
              <form class="form-inline">
                <div className="col-lg-12">
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label="Require comment"
                      checked={isCommentRequired}
                      onChange={toggleCommentRequirement}
                    />
                  </Form.Group>
                  <Form.Group>
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      placeholder={
                        isCommentRequired
                          ? "*Comment is compulsory to reject."
                          : "Optional Comment"
                      }
                      rows="3"
                      name="comment"
                      onChange={handleChange}
                    ></textarea>
                    {commentError && (
                      <div className="text-danger">{commentError}</div>
                    )}
                  </Form.Group>
                </div>
                <div className="col-lg-12">
                  <div className="serach-btn">
                    <a
                      href="javascript:void(0);"
                      id="next"
                      class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                      onClick={() =>
                        handleConfirm(candidateDetails.appl_id, 5, comment)
                      }
                    >
                      Reject
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="black-showd"></div>
        </div>
      )}
      {/* reject data popup */}

      {/* Onhold data popup */}
      {isSelected && (
        <div className="filter-shadow reject-people-data">
          <div className="filters-cards">
            <div className="filters-cards-cross">
              <div className="filter-content">
                <h4>Select Application</h4>
              </div>
              <div className="filter-content cross" onClick={selected_close}>
                <img src={cross} alt="" />
              </div>
            </div>
            <div className="bordertops"></div>
            <div className="reject-people data">
              <div className="data-people">
                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={name_icon} alt="" />
                  </div>
                  <div className="people-name">
                    <p>Name</p>
                    <h4>{candidateDetails.name}</h4>
                  </div>
                </div>

                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={job} alt="" />
                  </div>
                  <div className="people-name">
                    <p>Job Role</p>
                    <h4>{candidateDetails.vacancy?.title}</h4>
                  </div>
                </div>
              </div>

              <div className="data-people">
                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={education} alt="" />
                  </div>
                  <div className="people-name">
                    <p>Education</p>
                    <h4>{candidateDetails.highest_qualification}</h4>
                  </div>
                </div>

                <div className="people-biodata">
                  <div className="icon-name">
                    <img src={star_exp} alt="" />
                  </div>
                  <div className="people-name">
                    <p>Total Exp.</p>
                    <h4>{candidateDetails.job_user.total_experience}</h4>
                  </div>
                </div>
              </div>
            </div>
            <div className="filter-cards-form reject-data">
              <h4>Are you sure you want to Select the candidate?</h4>
              <p>
                Once you click 'Select', will not be considered for a job for
                the next three months.
              </p>
              <form class="form-inline">
                <div className="col-lg-12">
                  <Form.Group>
                    <textarea
                      class="form-control"
                      id="exampleFormControlTextarea1"
                      placeholder="Comment."
                      rows="3"
                      onChange={e => setComments(e.target.value)}
                    ></textarea>
                    {commentsError && (
                      <div className="text-danger">{commentsError}</div>
                    )}
                  </Form.Group>
                </div>
                <p>Upload Offer</p>
                <div className="col-lg-12">
                  <Form.Group>
                    <AvForm>
                      <AvField
                        type="file"
                        className="form-control"
                        id="offer_letter"
                        name="offer_letter"
                        errorMessage="offer_letter is required"
                        placeholder=" "
                        accept=".pdf, .doc, .docx"
                        onChange={e => setOfferLetter(e.target.files[0])}
                        validate={{ required: { value: true } }}
                      />
                    </AvForm>
                  </Form.Group>
                </div>
                <div className="col-lg-12">
                  <div className="serach-btn">
                    <a
                      href="javascript:void(0);"
                      id="next"
                      class="nxt_prev_ques btn btn-primary btn-lg next-btn"
                      onClick={() =>
                        handleSelected(
                          candidateDetails.appl_id,
                          candidateDetails.user_id
                        )
                      }
                    >
                      Select
                    </a>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div className="black-showd"></div>
        </div>
      )}
      <Modal size="lg" show={showModal} onHide={handleCloseModal}>
        <Modal.Header closeButton>
          <Modal.Title>Invite for Interview</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div id="msg-group"></div>
          <div className="row mb-3 invite-for-interview">
            <div className="form-group form-group-lg col-sm-8">
              <label>
                <strong>Candidate Name:</strong> {selectedCandidate.name}
              </label>
            </div>
            <div className="form-group form-group-lg col-sm-4 text-end">
              <label className="w-100 text-end">
                <strong>Role Type:</strong> {selectedCandidate.roleType}
              </label>
            </div>
            <div className="text-center mb-3 mt-3">
              <button className="btn btn-primary" onClick={handleToggleForm}>
                Schedule Next Round
              </button>
            </div>

            {isFormVisible && (
              <Form onSubmit={handleInterviewSubmit}>
                <div className="form-group">
                  <div className="row">
                    <div
                      id="int_schedule_date-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <label>Choose Date:</label>
                      <DatePicker
                        selected={formData?.int_schedule_date}
                        name="int_schedule_date"
                        onChange={date => {
                          let newFormData = JSON.parse(
                            JSON.stringify(formData)
                          );
                          newFormData.int_schedule_date = date;
                          setFormData(newFormData);
                        }}
                        minDate={new Date()}
                        className="form-control"
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Select Date"
                      />
                    </div>
                    <div
                      id="int_schedule_time-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <label>Available Slots:</label>
                      <select
                        id="int_schedule_time"
                        name="int_schedule_time"
                        className="datepicker form-control"
                        data-width="100%"
                        data-size="10"
                        title="Select Slot"
                        onChange={changeHandler}
                      >
                        <option value="09:00 AM - 10:00 AM">
                          09:00 AM - 10:00 AM
                        </option>
                        <option value="10:00 AM - 11:00 AM">
                          10:00 AM - 11:00 AM
                        </option>
                        <option value="11:00 AM - 12:00 PM">
                          11:00 AM - 12:00 PM
                        </option>
                        <option value="12:00 PM - 01:00 PM">
                          12:00 PM - 01:00 PM
                        </option>
                        <option value="01:00 PM - 02:00 PM">
                          01:00 PM - 02:00 PM
                        </option>
                        <option value="02:00 PM - 03:00 PM">
                          02:00 PM - 03:00 PM
                        </option>
                        <option value="03:00 PM - 04:00 PM">
                          03:00 PM - 04:00 PM
                        </option>
                        <option value="04:00 PM - 05:00 PM">
                          04:00 PM - 05:00 PM
                        </option>
                        <option value="05:00 PM - 06:00 PM">
                          05:00 PM - 06:00 PM
                        </option>
                      </select>
                    </div>
                    <div
                      id="interview-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <label>Enter Interview Title:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={changeHandler}
                        name="interview_title"
                        id="interview_title"
                        placeholder="Enter Interview Title"
                      />
                    </div>
                    <div
                      id="interviewer-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <label>Select Interviewer:</label>
                      <select
                        id="interviewere_time"
                        onChange={changeHandler}
                        name="interviewer_time"
                        className="form-select"
                        data-width="100%"
                        data-size="10"
                        title="Select Interviewer"
                      >
                        <option Selected>Select Interviewer</option>
                        <option value="1">Admin</option>
                        <option value="3">Eva Srivastava</option>
                      </select>
                    </div>
                    <div
                      id="address-group"
                      className="form-group form-group-lg col-sm-12 formvisible"
                    >
                      <label>Enter Address:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={changeHandler}
                        name="address"
                        id="address"
                        placeholder="Enter Address"
                      />
                    </div>
                    <div
                      id="req_documents-group"
                      className="form-group form-group-lg col-sm-12 formvisible"
                    >
                      <label>Required Documents (If Any)</label>
                      <textarea
                        type="text"
                        className="form-control"
                        onChange={changeHandler}
                        name="req_documents"
                        id="req_documents"
                        placeholder="Mention Documents Needed"
                      ></textarea>
                    </div>
                    <div
                      id="vitual-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <div className="form-checkbox d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="vitual"
                          id="vitual"
                          value="1"
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="vitual"
                        >
                          {" "}
                          Check this for Virtual Interview
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-action-btn text-center">
                  <button
                    type="submit"
                    className="btn btn-primary mb-2"
                    id="book_schedule"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            )}
            <ul>
              {scheduledInterviews.map(interview => (
                <li
                  key={interview.id}
                  id={`interview${interview.id}`}
                  className=" pb-0 mt-1"
                >
                  <div className="card-body">
                    <p>
                      {`${interview.interview_title} - admin (${interview.int_schedule_date}, ${interview.int_schedule_time})`}
                      {interview.candidate_status === 1 && " | Status (Done) "}
                    </p>
                    {(interview.candidate_status === 0 ||
                      interview.candidate_status == 3) && (
                      <div className="inteview-selected pt-3">
                        <a
                          href="javascript:void(0)"
                          className="delete_interview"
                          data-id={interview.id}
                          onClick={() => handleDeleteInterview(interview.id)}
                        >
                          {`${interview.candidate_status}` == 0
                            ? "Delete"
                            : "Declined"}
                        </a>

                        <a
                          href="javascript:void(0)"
                          className="Reschedule_interview"
                          data-id={interview.id}
                          onClick={() => handleToggleForm2(interview.id)}
                        >
                          Reschedule
                        </a>

                        <a
                          href="javascript:void(0)"
                          className="pending-schedule"
                        >
                          {" Status " +
                            (`${interview.candidate_status}` === "1"
                              ? "(Done)"
                              : "(Pending)")}
                        </a>

                        <a
                          href="javascript:void(0)"
                          className="feedback_interview"
                          data-id={interview.id}
                          onClick={() => handleToggleFeeddback(interview.id)}
                        >
                          Feedback
                        </a>

                        {interview?.candidate_status == 3 ? (
                          <a
                            href={`candidate-reschedule/${interview.id}`}
                            className="Reschedule_interview"
                            data-id={interview.id}
                          >
                            Candidate Reschedule Request
                          </a>
                        ) : (
                          ""
                        )}
                      </div>
                    )}
                  </div>
                </li>
              ))}
            </ul>
            {isForm2Visible && (
              <Form onSubmit={handleRescheduleSubmit}>
                <div className="form-group">
                  <div className="row">
                    <div
                      id="int_schedule_date-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <label>Choose Date:</label>
                      <DatePicker
                        selected={formDatas?.int_schedule_date}
                        name="int_schedule_date"
                        onChange={date => {
                          let newFormData = JSON.parse(
                            JSON.stringify(formDatas)
                          );
                          newFormData.int_schedule_date = date;
                          setrescheduleData(newFormData);
                        }}
                        minDate={new Date()}
                        className="form-control"
                        dateFormat="yyyy-MM-dd"
                        placeholderText="Select Date"
                      />
                    </div>
                    <div
                      id="int_schedule_time-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <label>Available Slots:</label>
                      <select
                        id="int_schedule_time"
                        name="int_schedule_time"
                        className="datepicker form-control"
                        data-width="100%"
                        data-size="10"
                        title="Select Slot"
                        onChange={changeHandlers}
                      >
                        <option value="09:00 AM - 10:00 AM">
                          09:00 AM - 10:00 AM
                        </option>
                        <option value="10:00 AM - 11:00 AM">
                          10:00 AM - 11:00 AM
                        </option>
                        <option value="11:00 AM - 12:00 PM">
                          11:00 AM - 12:00 PM
                        </option>
                        <option value="12:00 PM - 01:00 PM">
                          12:00 PM - 01:00 PM
                        </option>
                        <option value="01:00 PM - 02:00 PM">
                          01:00 PM - 02:00 PM
                        </option>
                        <option value="02:00 PM - 03:00 PM">
                          02:00 PM - 03:00 PM
                        </option>
                        <option value="03:00 PM - 04:00 PM">
                          03:00 PM - 04:00 PM
                        </option>
                        <option value="04:00 PM - 05:00 PM">
                          04:00 PM - 05:00 PM
                        </option>
                        <option value="05:00 PM - 06:00 PM">
                          05:00 PM - 06:00 PM
                        </option>
                      </select>
                    </div>

                    <div
                      id="address-group"
                      className="form-group form-group-lg col-sm-12 formvisible"
                    >
                      <label>Enter Address:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={changeHandlers}
                        name="f2f_address"
                        id="address"
                        placeholder="Enter Address"
                      />
                    </div>
                    <div
                      id="vitual-group"
                      className="form-group form-group-lg col-sm-6 formvisible"
                    >
                      <div className="form-checkbox d-flex align-items-center gap-2">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          name="vitual"
                          id="vitual"
                          value="1"
                        />
                        <label
                          className="form-check-label mb-0"
                          htmlFor="vitual"
                        >
                          {" "}
                          Check this for Virtual Interview
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="modal-action-btn text-center mt-2">
                  <button
                    type="submit"
                    className="btn btn-primary"
                    id="book_schedule"
                  >
                    Submit
                  </button>
                </div>
              </Form>
            )}

            {isForm3Visible && (
              <Form onSubmit={handlefeedbackSubmit}>
                <div className="form-group">
                  <div className="row">
                    <div
                      id="address-group"
                      className="form-group form-group-lg col-sm-12"
                    >
                      <label>Enter Comment:</label>
                      <input
                        type="text"
                        className="form-control"
                        onChange={changecomment}
                        name="comment"
                        id="comment"
                        placeholder="Enter comment"
                      />
                    </div>
                  </div>
                </div>
                <div className="modal-action-btn text-center mt-2">
                  <button type="submit" className="btn btn-primary">
                    Submit
                  </button>
                </div>
              </Form>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default ScheduledList;
